import React from 'react'
import { Modal } from '../../../components/_EOS/Modal'
import { ModalReturnType } from '../../../hooks/useModal'
import { Asn } from '../../../interfaces/Asn/Asn'
import { AsnBlog } from '../../../components'

interface ASNBlogModalProps {
  blogModalState: ModalReturnType<Asn>
}

export const ASNBlogModal: React.FC<ASNBlogModalProps> = ({
  blogModalState
}) => {
  return (
    <Modal
      open={blogModalState.isOpen}
      maxWidth={blogModalState.size}
      title={blogModalState.title}
      onClose={blogModalState.closeModal}
    >
      {blogModalState.extendedProps && (
        <AsnBlog
          asnId={blogModalState.extendedProps.asnId}
          asnNumber={blogModalState.extendedProps.asnNumber}
          onClose={blogModalState.closeModal}
        />
      )}
    </Modal>
  )
}

